import BaseService from "./BaseService.js";

class AmpService extends BaseService {
  get(query) {
    return this.apiGet({
      url: "/tif/amp",
      params: query
    });
  }

  getData(query) {
    return this.apiGet({
      url: "/tif/form",
      params: query
    });
  }

  getOne(id, token, sourceId) {
    if (token) {
      return this.apiGet({
        url: "/tif/amp/" + id,
        headers: token ? {
          Authorization: `Bearer ${token}`,
          'ngrok-skip-browser-warning': true,
        } : undefined,
      });
    }

    return this.apiGet({
      url: "/tif/amp/" + id,
      params: { source: sourceId },
    });
  }

  approveApplication(payload, view) {
    switch (view) {
      case 'mine-profile':
        return this.apiPut({
          url: `/tif/amp/approveForm/${payload.id}?formNamespace=mine-profile`,
        });
      case 'ownership-kyc':
        return this.apiPut({
          url: `/tif/amp/approveForm/${payload.id}?formNamespace=kyc`,
        });
      default:
        return this.apiPut({
          url: `/tif/amp/approve/${payload.id}`,
        });
    }
  }

  declineApplication(payload, view) {
    switch (view) {
      case 'mine-profile':
        return this.apiPut({
          url: `/tif/amp/declineForm/${payload.id}?formNamespace=mine-profile`,
        });
      case 'ownership-kyc':
        return this.apiPut({
          url: `/tif/amp/declineForm/${payload.id}?formNamespace=kyc`,
        });
      default:
        return this.apiPut({
          url: `/tif/amp/decline/${payload.id}`,
        });
    }
  }

  editApplication(payload) {
    return this.apiPut({
      url: `/tif/amp/editAmp/${payload.id}?tifAmpStatus=${payload.tifAmpStatus}`,
    });
  }

  changeStatusApplication(payload) {
    return this.apiPut({
      url: `/tif/amp/changeStatus/${payload.dbId}?status=${payload.status}`,
    });
  }

  submit(payload) {
    if (payload.id) {
      const { id, view, ...data } = payload;
      return this.apiPut({
        url: `/tif/amp/${id}?formNamespace=${view}`,
        data,
      });
    }
    return this.apiPost({
      url: "/tif/amp/",
      data: payload,
    });
  }

  submitForm(id) {
    return this.apiPut({
      url: `/tif/amp/submit/${id}`,
    });
  }

  formSubmit(id, type) {
    return this.apiPut({
      url: `/tif/amp/submitForm/${id}?formNamespace=${type}`,
    });
  }

  getTifDashboard(id) {
    return this.apiGet({
      url: `/tif/dashboard/${id}?namespace=tif`
    })
  }

  inviteAmp(data) {
    return this.apiPut({
      url: `/tif/amp/${data.id}/invite`,
      data,
    })
  }

  getAmpDashboard() {
    return this.apiGet({
      url: `/tif/amp-dashboard`,
    })
  }
}

export default new AmpService();
